var map = {
	"app/chat/chat.module": [
		"../../../../../src/app/chat/chat.module.ts",
		"chat.module"
	],
	"app/danhmuc/danh-muc.module": [
		"../../../../../src/app/danhmuc/danh-muc.module.ts",
		"common",
		"danh-muc.module"
	],
	"app/danhmuc/dm-doi-tuong/dm-doi-tuong.module": [
		"../../../../../src/app/danhmuc/dm-doi-tuong/dm-doi-tuong.module.ts",
		"common",
		"dm-doi-tuong.module"
	],
	"app/dieu-hanh/dieu-hanh.module": [
		"../../../../../src/app/dieu-hanh/dieu-hanh.module.ts",
		"dieu-hanh.module"
	],
	"app/he-thong/he-thong.module": [
		"../../../../../src/app/he-thong/he-thong.module.ts",
		"he-thong.module",
		"common"
	],
	"app/hop-khong-giay/hop-khong-giay.module": [
		"../../../../../src/app/hop-khong-giay/hop-khong-giay.module.ts",
		"common",
		"hop-khong-giay.module"
	],
	"app/login/bypass-sso/bypass-sso.module": [
		"../../../../../src/app/login/bypass-sso/bypass-sso.module.ts",
		"bypass-sso.module"
	],
	"app/nang-cao/nang-cao.module": [
		"../../../../../src/app/nang-cao/nang-cao.module.ts",
		"common",
		"nang-cao.module"
	],
	"app/phan-anh/phan-anh.module": [
		"../../../../../src/app/phan-anh/phan-anh.module.ts",
		"common",
		"phan-anh.module"
	],
	"app/quanly-canhbao/quanly-canhbao.module": [
		"../../../../../src/app/quanly-canhbao/quanly-canhbao.module.ts",
		"common",
		"quanly-canhbao.module"
	],
	"app/sanpham/san-pham.module": [
		"../../../../../src/app/sanpham/san-pham.module.ts",
		"common",
		"san-pham.module"
	],
	"app/shared/print-chart/print-chart.module": [
		"../../../../../src/app/shared/print-chart/print-chart.module.ts",
		"print-chart.module"
	],
	"app/thiet-bi/thiet-bi.module": [
		"../../../../../src/app/thiet-bi/thiet-bi.module.ts",
		"common",
		"thiet-bi.module"
	],
	"app/thong-ke/thong-ke.module": [
		"../../../../../src/app/thong-ke/thong-ke.module.ts",
		"common",
		"thong-ke.module"
	],
	"app/tien-ich/tien-ich.module": [
		"../../../../../src/app/tien-ich/tien-ich.module.ts",
		"common",
		"tien-ich.module"
	],
	"app/xu-ly/xl-xac-nhan-xu-ly/xl-xac-nhan-xu-ly.module": [
		"../../../../../src/app/xu-ly/xl-xac-nhan-xu-ly/xl-xac-nhan-xu-ly.module.ts",
		"common",
		"xl-xac-nhan-xu-ly.module"
	],
	"app/xu-ly/xl-xu-ly-su-co/xu-ly-su-co.module": [
		"../../../../../src/app/xu-ly/xl-xu-ly-su-co/xu-ly-su-co.module.ts",
		"common",
		"xu-ly-su-co.module"
	],
	"app/xu-ly/xu-ly.module": [
		"../../../../../src/app/xu-ly/xu-ly.module.ts",
		"common",
		"xu-ly.module"
	],
	"app/xu-phat-hanh-chinh/xu-phat-hanh-chinh.module": [
		"../../../../../src/app/xu-phat-hanh-chinh/xu-phat-hanh-chinh.module.ts",
		"common",
		"xu-phat-hanh-chinh.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src lazy recursive";


//////////////////
// WEBPACK FOOTER
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src lazy
// module id = ../../../../../src lazy recursive
// module chunks = main